import React, { Component } from 'react'
import { hot } from 'react-hot-loader'

import './app.css'

import 'semantic-ui-css/semantic.min.css';

import {Segment, Header, Button} from 'semantic-ui-react';

import {InteractivesWrapper} from './InteractivesWrapper.js';
import {PropertiesTable} from './PropertiesTable.js';


class App extends Component {


  constructor(props) {
    super(props);

    this.state = {
      name: '',
      interactive: undefined,
      manifest: undefined,
      counter: 1
    };

    this.onInteractiveReady = this.onInteractiveReady.bind(this);
    this.onStateChanged = this.onStateChanged.bind(this);
  }

  onInteractiveReady(interactive) {
    let manifest = interactive.getManifest();
    this.setState({
      interactive: interactive,
      manifest: manifest,
      name: manifest.details.fullName
    });
  }

  onStateChanged(detail) {
    this.markAsDirty();
  }

  markAsDirty() {
    let newCounter = this.state.counter + 1;
    this.setState({counter: newCounter});
  }

  render () {

    return (
      <div style={{backgroundColor: '#eee', height: '100%'}}>
        <InteractivesWrapper
          onInteractiveReady = {this.onInteractiveReady}
          onStateChanged = {this.onStateChanged}
        />
        <Segment padded style={{width: '800px', margin: '2em auto'}}>
          <Header>{this.state.name}</Header>

          <PropertiesTable
            interactive = {this.state.interactive}
            manifest = {this.state.manifest}
          />

          <Button
            onClick={(e) => {
              let state = this.state.interactive.getState();
              navigator.clipboard.writeText(JSON.stringify(state, null, 1));
            }}
            disabled={this.state.interactive === undefined}
            style={{margin: '1em auto', display: 'block'}}
          >Copy State to Clipboard</Button>

          <Button
            onClick={(e) => {
              let state = this.state.interactive.getState();
              navigator.clipboard.writeText(JSON.stringify(state));
            }}
            disabled={this.state.interactive === undefined}
            style={{margin: '1em auto', display: 'block'}}
          >Copy State to Clipboard (Compact)</Button>

          <Button
            onClick={(e) => {
              this.state.interactive.reset();
            }}
            disabled={this.state.interactive === undefined}
            style={{margin: '1em auto', display: 'block'}}
          >Reset</Button>

        </Segment>
      </div>
    );
  }

}

export default hot(module)(App)

